import { get } from "lodash";
import { useAuthUserStore } from "@/stores/authUser";

export default function({ to, from }) {
    const authUserStore = useAuthUserStore();
    if (to.name === "settings.changepassword") {
        if (Object.prototype.hasOwnProperty.call(from.query, "continue")) {
            return {
                name: "settings.changepassword",
                query: {
                    continue: from.query.continue
                }
            };
        }
        return;
    }
    const u = authUserStore.user;
    if (u && mustChangePassword(u)) {
        let query = {};
        if (Object.prototype.hasOwnProperty.call(from.query, "continue")) {
            query.continue = from.query.continue;
        }
        return {
            name: "settings.changepassword",
            query
        };
    }
}

function mustSetPassword(user) {
    return (
        !user?.silent &&
        user.password_changed_at === null &&
        !user?.logged_in_parent &&
        get(user.related?.account?.settings, "sso.must_set_password", false)
    );
}

function mustChangePassword(user) {
    if (mustSetPassword(user)) {
        return true;
    }
    if (user?.silent || user.password_changed_at == null || user?.logged_in_parent) {
        return false;
    }
    let lastChanged = new Date(user.password_changed_at);
    if (lastChanged < new Date("2000-01-01")) {
        return true;
    }

    let expires = get(
        user?.related?.account?.settings,
        "sso.password_expiry_months",
        false
    );
    if (!expires) {
        return false;
    }
    let expiresDate = new Date();
    expiresDate.setMonth(expiresDate.getMonth() - expires);

    return lastChanged < expiresDate;
}
